import { usePermissionStore } from '@/store/modules/permission'
import createAuth from '@fe/zxwy-utils/directives/v-auth'

export default {
  install(app) {
    const auth = createAuth((mark) => usePermissionStore().authInstance.validate(mark))

    app.directive(auth.name, auth)
  }
}
